export const normalizeHomeRoutePathname = (pathname: string): string =>
  pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

export const isInvestorProfileRoute = (pathname: string): boolean =>
  /^\/home\/clients\/[^/]+\/profile$/.test(normalizeHomeRoutePathname(pathname));

export const isClientsListRoute = (pathname: string): boolean =>
  normalizeHomeRoutePathname(pathname) === '/home/clients';

export const isMeetingHubRoute = (pathname: string): boolean =>
  normalizeHomeRoutePathname(pathname) === '/home/meetinghub';

// The client detail page (/home/clients/:investorId) renders its own header
// (back button + client name), so the shared "Clients" page header must be
// hidden there. Excludes the list (/home/clients), the add-client route
// (/home/clients/new) and the profile subroute.
export const isInvestorDetailRoute = (pathname: string): boolean =>
  /^\/home\/clients\/(?!new$)[^/]+$/.test(normalizeHomeRoutePathname(pathname));

export const isInvestorPlanRoute = (pathname: string): boolean =>
  /^\/home\/clients\/[^/]+\/plan\/[^/]+$/.test(normalizeHomeRoutePathname(pathname));

export const isScrollableNoHeaderRoute = (pathname: string): boolean =>
  isClientsListRoute(pathname) ||
  isInvestorProfileRoute(pathname) ||
  isInvestorDetailRoute(pathname);
